export class Pool {
	constructor(type, size, model) {
		this._type = null;
		this._size = null;
		this._pointer = null;
		this._elements = null;

		this.init(type, size, model);
		return this;
	}

	init(type, size, model) {
		this._type = type;
		this._size = size;
		this._pointer = size;
		this._elements = [];

		var i = 0;
		var length = this._size;

		for (i; i < length; ++i) {
			this._elements[i] = new this._type(model);
		}
	}

	getElement() {
		if (this._pointer > 0) return this._elements[--this._pointer];

		return null;
	}

	disposeElement(obj) {
		this._elements[this._pointer++] = obj;
	}
}
